import React, { useEffect, useState } from 'react';
import { toast } from '../ui.jsx';
import { getApiBase } from '../apiBase';

const API_BASE = getApiBase();
function NewAdmissions() {
  const [admissions, setAdmissions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [noteModal, setNoteModal] = React.useState(null);
  const API = `${API_BASE}/admissions`;

  const token = () => sessionStorage.getItem('lkps_token') || '';

  const load = async () => {
    setLoading(true);
    try {
      const r = await fetch(API, { headers: { Authorization: 'Bearer ' + token() } });
      const data = await r.json();
      setAdmissions(Array.isArray(data) ? data : []);
    } catch { toast('Failed to load admissions', 'err'); }
    setLoading(false);
  };

  React.useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await fetch(`${API}/${id}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token() }, body: JSON.stringify({ status }) });
      setAdmissions(a => a.map(x => x._id === id ? { ...x, status } : x));
      toast('Status updated');
    } catch { toast('Update failed', 'err'); }
  };

  const saveNote = async () => {
    try {
      await fetch(`${API}/${noteModal.id}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token() }, body: JSON.stringify({ note: noteModal.note }) });
      setAdmissions(a => a.map(x => x._id === noteModal.id ? { ...x, note: noteModal.note } : x));
      toast('Note saved'); setNoteModal(null);
    } catch { toast('Save failed', 'err'); }
  };

  const del = async (id) => {
    if (!window.confirm('Remove this enquiry?')) return;
    try {
      await fetch(`${API}/${id}`, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token() } });
      setAdmissions(a => a.filter(x => x._id !== id));
      toast('Removed');
    } catch { toast('Delete failed', 'err'); }
  };

  const STATUS_COLORS = { Pending: '#f59e0b', Contacted: '#3b82f6', Enrolled: '#10b981', Rejected: '#ef4444' };
  const STATUS_BG = { Pending: '#fef3c7', Contacted: '#dbeafe', Enrolled: '#d1fae5', Rejected: '#fee2e2' };

  const counts = { Pending: 0, Contacted: 0, Enrolled: 0, Rejected: 0 };
  admissions.forEach(a => { if (counts[a.status] !== undefined) counts[a.status]++; });
  const formatReceivedDate = (value) => new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <div>
      {/* Summary cards */}
      <div className="admissions-summary-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 24 }}>
        {Object.entries(counts).map(([s, n]) => (
          <div key={s} style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', border: '1px solid #e8edf5', boxShadow: '0 2px 12px rgba(0,32,69,0.06)' }}>
            <div style={{ fontSize: 28, fontWeight: 900, color: STATUS_COLORS[s], fontFamily: 'Manrope,sans-serif' }}>{n}</div>
            <div style={{ fontSize: 12, color: '#64748b', fontWeight: 600, marginTop: 4 }}>{s}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-head">
          <div className="card-title">New Admission Enquiries ({admissions.length})</div>
          <button className="btn" onClick={load} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span className="material-symbols-outlined" style={{ fontSize: 15 }}>refresh</span> Refresh
          </button>
        </div>
        <div className="table-wrap">
          {loading ? (
            <div className="no-data"><span className="material-symbols-outlined no-data-icon">hourglass_top</span>Loading…</div>
          ) : admissions.length === 0 ? (
            <div className="no-data"><span className="material-symbols-outlined no-data-icon">inbox</span>No enquiries yet</div>
          ) : (
            <>
              <table className="admissions-desktop-table">
                <thead><tr><th>#</th><th>Name</th><th>Phone</th><th>Email</th><th>Status</th><th>Note</th><th>Received</th><th>Actions</th></tr></thead>
                <tbody>
                  {admissions.map((a, i) => (
                    <tr key={a._id}>
                      <td style={{ color: '#94a3b8', fontSize: 12 }}>{i + 1}</td>
                      <td style={{ fontWeight: 700 }}>{a.name}</td>
                      <td>
                        <a href={`tel:${a.phone}`} style={{ color: '#1960a3', textDecoration: 'none', fontWeight: 600 }}>{a.phone}</a>
                      </td>
                      <td style={{ color: '#64748b' }}>{a.email || <span style={{ color: '#cbd5e1' }}>—</span>}</td>
                      <td>
                        <select value={a.status} onChange={e => updateStatus(a._id, e.target.value)}
                          style={{ padding: '4px 10px', borderRadius: 20, border: 'none', fontWeight: 700, fontSize: 11, cursor: 'pointer', background: STATUS_BG[a.status], color: STATUS_COLORS[a.status], fontFamily: 'inherit' }}>
                          {['Pending', 'Contacted', 'Enrolled', 'Rejected'].map(s => <option key={s}>{s}</option>)}
                        </select>
                      </td>
                      <td style={{ maxWidth: 180, color: '#475569', fontSize: 12 }}>
                        {a.note ? <span title={a.note}>{a.note.length > 40 ? a.note.slice(0, 40) + '…' : a.note}</span> : <span style={{ color: '#cbd5e1' }}>—</span>}
                      </td>
                      <td style={{ color: '#94a3b8', fontSize: 12, whiteSpace: 'nowrap' }}>
                        {formatReceivedDate(a.createdAt)}
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn btn-sm" onClick={() => setNoteModal({ id: a._id, note: a.note || '' })}
                            title="Add note" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span className="material-symbols-outlined" style={{ fontSize: 13 }}>edit_note</span>
                          </button>
                          <button className="btn btn-sm btn-danger" onClick={() => del(a._id)}
                            title="Delete" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span className="material-symbols-outlined" style={{ fontSize: 13 }}>delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="admissions-mobile-list">
                {admissions.map((a, i) => (
                  <div key={a._id} className="admissions-mobile-card">
                    <div className="admissions-mobile-head">
                      <div>
                        <div className="admissions-mobile-index">Enquiry #{i + 1}</div>
                        <div className="admissions-mobile-name">{a.name}</div>
                      </div>
                      <select value={a.status} onChange={e => updateStatus(a._id, e.target.value)}
                        style={{ padding: '6px 10px', borderRadius: 20, border: 'none', fontWeight: 700, fontSize: 11, cursor: 'pointer', background: STATUS_BG[a.status], color: STATUS_COLORS[a.status], fontFamily: 'inherit' }}>
                        {['Pending', 'Contacted', 'Enrolled', 'Rejected'].map(s => <option key={s}>{s}</option>)}
                      </select>
                    </div>

                    <div className="admissions-mobile-meta">
                      <div className="admissions-mobile-row">
                        <span className="material-symbols-outlined">call</span>
                        <a href={`tel:${a.phone}`}>{a.phone}</a>
                      </div>
                      <div className="admissions-mobile-row">
                        <span className="material-symbols-outlined">mail</span>
                        <span>{a.email || 'No email provided'}</span>
                      </div>
                      <div className="admissions-mobile-row">
                        <span className="material-symbols-outlined">calendar_month</span>
                        <span>{formatReceivedDate(a.createdAt)}</span>
                      </div>
                      <div className="admissions-mobile-note">
                        <span className="admissions-mobile-note-label">Note</span>
                        <p>{a.note || 'No note added yet.'}</p>
                      </div>
                    </div>

                    <div className="admissions-mobile-actions">
                      <button className="btn" onClick={() => setNoteModal({ id: a._id, note: a.note || '' })} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>edit_note</span>
                        Add note
                      </button>
                      <button className="btn btn-danger" onClick={() => del(a._id)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>delete</span>
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Note modal */}
      {noteModal && (
        <div className="overlay" onClick={() => setNoteModal(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-title">Add / Edit Note</div>
            <textarea value={noteModal.note} onChange={e => setNoteModal(n => ({ ...n, note: e.target.value }))}
              placeholder="Write a note about this enquiry…"
              style={{ width: '100%', minHeight: 100, padding: '10px 12px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: 13, fontFamily: 'inherit', resize: 'vertical', outline: 'none' }} />
            <div className="modal-footer">
              <button className="btn" onClick={() => setNoteModal(null)}>Cancel</button>
              <button className="btn btn-primary" onClick={saveNote}>Save Note</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


export default NewAdmissions;
